import React from 'react';
import block from 'bem-cn';

import Button from 'components/Button';
import Input from 'components/Input';
import Logo from 'components/Logo';
import SVG from 'components/SVG';
import PasswordComplexityStatus from 'components/PasswordComplexityStatus';

import useRequiredChangePassword from 'features/users/model/useRequiredChangePassword';

import crossSVG from 'shared/img/cross.svg';

import './RequiredChangePassword.scss';

const b = block('required-change-password');

const RequiredChangePassword = ({ canClose = true, onSuccess }) => {
  const {
    form,
    locale,
    complexity,
    disabled,
    isPasswordsMatched,
    closeModal,
    changeValue,
    onSubmit,
  } = useRequiredChangePassword({ onSuccess });

  return (
    <div className={b()}>
      <div className={b('header')}>
        <div className={b('header-logo')}>
          <Logo />
        </div>

        {canClose && (
          <button type="button" className={b('header-close')} onClick={closeModal} aria-label={locale.close}>
            <SVG svgProps={{ svg: crossSVG }} containerClassName={b('header-close-icon').toString()} />
          </button>
        )}
      </div>

      <form className={b('form')} onSubmit={onSubmit}>
        <div className={b('form-title')}>{locale.changePassword}</div>

        <div className={b('form-field')}>
          <span className={b('form-field-label')}>{locale.oldPassword}</span>
          <div className={b('form-field-input')}>
            <Input
              withEye
              type="password"
              color="transparent"
              name="oldPassword"
              value={form.oldPassword}
              onChange={changeValue}
            />
          </div>
        </div>

        <div className={b('form-field')}>
          <span className={b('form-field-label')}>{locale.newPassword}</span>
          <div className={b('form-field-input')}>
            <Input
              withEye
              type="password"
              color="transparent"
              name="newPassword"
              value={form.newPassword}
              onChange={changeValue}
            />
          </div>

          {complexity.isStarted && complexity.requirements.length > 0 && (
            <PasswordComplexityStatus
              requirements={complexity.requirements}
              activeBarsCount={complexity.activeBarsCount}
              activeColor={complexity.activeColor}
            />
          )}
        </div>

        <div className={b('form-field')}>
          <span className={b('form-field-label')}>{locale.repeatNewPassword}</span>
          <div className={b('form-field-input')}>
            <Input
              withEye
              type="password"
              color="transparent"
              name="confirmNewPassword"
              value={form.confirmNewPassword}
              onChange={changeValue}
              validState={form.confirmNewPassword.length > 0 && !isPasswordsMatched ? 3 : 1}
            />
          </div>
        </div>

        {complexity.requirementText && (
          <div className={b('form-requirements')}>
            <span className={b('form-requirements-mark')}>*</span>
            <p className={b('form-requirements-text')}>{complexity.requirementText}</p>
          </div>
        )}

        <div className={b('form-submit')}>
          <Button disabled={disabled} type="submit" size="high" text={locale.save} />
        </div>
      </form>
    </div>
  );
};

export default RequiredChangePassword;
